import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';

// Pages
import Home from './pages/Home';
import SecurityDetail from './pages/SecurityDetail';
import Securities from './pages/Securities';
import Register from './pages/Register';
import Login from './pages/Login';
import Leaderboards from './pages/Leaderboards';
import Portfolio from './pages/Portfolio';
import UserProfile from './pages/UserProfile';
import Forums from './pages/Forums';
import ForumPost from './pages/ForumPost';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/security/:symbol" element={<SecurityDetail />} />
            <Route path="/securities" element={<Securities />} />
            <Route path="/securities/movies" element={<Securities />} />
            <Route path="/securities/stars" element={<Securities />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/leaderboards" element={<Leaderboards />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/profile/:username" element={<UserProfile />} />
            <Route path="/forum" element={<Forums />} />
            <Route path="/forum/post/:postId" element={<ForumPost />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
